/**
 * THE shared sale-stage ranking — the single source of truth for "which buyer is further
 * along", used by BOTH the salesByUnit winner selection in joinCore and the ⚠ GHL stale-guard
 * in the Sales dock config, so the two can never diverge.
 *
 * Owner's precedence rule (2026-06): when multiple buyers claim a unit/lot, the buyer further
 * along the sale process is the ONLY buyer shown. Stage order, highest wins:
 *   Sold / Escrow Received (escrow-funded == Sold, per standing rule)  → 6
 *   Countersigned / Waiting for Escrow (any under-contract wording)    → 5
 *   Sent to Client                                                     → 4
 *   Client Requested                                                   → 3
 *   Waiting for Request                                                → 2
 *   anything else (Available / blank / unknown active)                 → 0
 *   Cancelled / Lost / Abandoned — dead deals NEVER beat an active one → -1
 * Maps either vocabulary (Unit Contract Status / GHL stage strings) onto the same scale, so
 * comparisons measure *progress*, not raw wording.
 */
export const normStage = (s: string): string => (s || '').toLowerCase().replace(/[^a-z]/g, '');

export const stageRank = (s: string): number => {
  const n = normStage(s);
  if (!n) return 0;
  if (n.includes('cancel') || n.includes('lost') || n.includes('abandon')) return -1;
  // Countersigned BEFORE the escrow check: "Countersigned / Waiting for Escrow" contains
  // "escrow" and must NOT rank as escrow-funded (the old local rank had exactly that bug).
  if (n.includes('countersigned') || n.includes('undercontract')) return 5;
  if (n.includes('sold') || n.includes('closed') || n === 'co' || n.includes('escrow')) return 6;
  if (n.includes('contract')) return 5;
  if (n.includes('sent')) return 4;                 // Sent to Client
  if (n.includes('waitingforrequest')) return 2;    // before the generic "request" check
  if (n.includes('request')) return 3;              // Client Requested
  return 0;
};
